const parseBoolean = (value, defaultValue) => {
  if (value === undefined) return defaultValue;
  return String(value).toLowerCase() === "true";
};

const runtimeEnv = window.__ENV || {};

const appConfig = {
  auth: {
    enableKeycloak: parseBoolean(
      runtimeEnv.REACT_APP_ENABLE_KEYCLOAK ?? process.env.REACT_APP_ENABLE_KEYCLOAK,
      false
    ),
  },
};

export default appConfig;
